module.exports = __webpack_public_path__ + "img/agenda.ee9c3423.svg";